import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { ComponentTitle, ComponentBody } from "./Common";
import { AddCommaNumber } from "../../../helpers/Utils";
import IntlMessages from "../../../helpers/IntlMessages";

export default (props) => {
  const [state, setState] = useState({
    columns: [],
  });

  useEffect(() => {
    setState({
      ...state,
      columns: [
        {
          Header: <div style={{ textAlign: "center" }}>{props.title}</div>,
          columns: [
            {
              Header: <IntlMessages id="analytics.table.stt" />,
              accessor: "stt",
              maxWidth: 50,
            },
            {
              Header: <IntlMessages id="analytics.table.name" />,
              accessor: "label",
              minWidth: 130,
            },
            {
              Header: (
                <ComponentTitle
                  compare={props.setting.compare}
                  title={<IntlMessages id="analytics.table.quantity" />}
                  value={props.total_count}
                  align="center"
                />
              ),
              accessor: "count",
              Cell: (_props) => {
                // console.log(_props);
                const value = _props.value + " " + "sản phẩm";
                return (
                  <ComponentBody
                    compare={props.setting.compare}
                    all={props.setting.all}
                    type="text"
                    align="center"
                    value={value}
                    compare_value={_props.original.compare_count}
                  />
                );
              },
            },
            {
              Header: (
                <ComponentTitle
                  compare={props.setting.compare}
                  title={<IntlMessages id="analytics.table.revenue" />}
                  value={AddCommaNumber(props.total_price)}
                  align="center"
                />
              ),
              minWidth: 160,
              accessor: "price",
              sortMethod: (a, b) => Number(a) - Number(b),
              Cell: (_props) => (
                <ComponentBody
                  compare={props.setting.compare}
                  all={props.setting.all}
                  type="price"
                  align="center"
                  value={_props.value}
                  compare_value={_props.original.compare_price}
                />
              ),
            },
            {
              Header: (
                <ComponentTitle
                  compare={props.setting.compare}
                  title={<IntlMessages id="analytics.table.gift" />}
                  value={props.total_gift_count || 0}
                  align="center"
                />
              ),
              accessor: "gift_count",
              Cell: (_props) => {
                const value = (_props.value || 0) + " " + "sản phẩm";
                return (
                  <ComponentBody
                    compare={props.setting.compare}
                    all={props.setting.all}
                    type="text"
                    align="center"
                    value={value}
                    compare_value={_props.original.compare_gift_count}
                  />
                );
              },
            },
            {
              Header: (
                <ComponentTitle
                  compare={props.setting.compare}
                  title={<IntlMessages id="analytics.table.discount" />}
                  value={AddCommaNumber(props.total_discount)}
                  align="center"
                />
              ),
              minWidth: 160,
              accessor: "discount",
              Cell: (_props) => (
                <ComponentBody
                  compare={props.setting.compare}
                  all={props.setting.all}
                  type="price"
                  align="center"
                  value={_props.value}
                  compare_value={_props.original.compare_discount}
                />
              ),
            },
          ],
        },
      ],
    });
  }, [props.data, props.setting.compare, props.setting.all]);

  return (
    <ReactTable
      defaultPageSize={8}
      data={props.data}
      columns={state.columns}
      minRows={0}
      showPageJump={false}
      showPageSizeOptions={true}
      PaginationComponent={Pagination}
      NoDataComponent={() => null}
    />
  );
};
